import useSound from "use-sound";

// ✅ Import all Amharic sounds
import pauseAm from "../sounds/pause.mp3";
import readyAm from "../sounds/be ready.mp3";
import cleanAm from "../sounds/be-ready.mp3";
import successAm from "../sounds/success.mp3";
import failAm from "../sounds/Fail.mp3";

// ✅ Import all English sounds
import pauseEn from "../sounds/en/pause.mp3";
import readyEn from "../sounds/en/be ready.mp3";
import cleanEn from "../sounds/en/be-ready.mp3";
import successEn from "../sounds/en/success.mp3";
import failEn from "../sounds/en/Fail.mp3";

// ✅ Import all Oromo sounds
import pauseOr from "../sounds/or/pause.mp3";
import readyOr from "../sounds/or/be ready.mp3";
import cleanOr from "../sounds/or/be-ready.mp3";
import successOr from "../sounds/or/success.mp3";
import failOr from "../sounds/or/Fail.mp3";

// ✅ Language-specific sound mappings
const soundFiles = {
  am: {
    pause: pauseAm,
    ready: readyAm,
    clean: cleanAm,
    success: successAm,
    fail: failAm,
  },
  en: {
    pause: pauseEn,
    ready: readyEn,
    clean: cleanEn,
    success: successEn,
    fail: failEn,
  },
  or: {
    pause: pauseOr,
    ready: readyOr,
    clean: cleanOr,
    success: successOr,
    fail: failOr,
  },
};

/**
 * Hook: useFunctionalSounds
 * Returns functions to play sounds based on the selected language
 */
export function useFunctionalSounds(language = "am") {
  const files = soundFiles[language] || soundFiles.am;

  // Create play functions dynamically
  const [playPause] = useSound(files.pause);
  const [playReady] = useSound(files.ready);
  const [playClean] = useSound(files.clean);
  const [playSuccess] = useSound(files.success);
  const [playFail] = useSound(files.fail);

  return {
    playPause,
    playReady,
    playClean,
    playSuccess,
    playFail,
  };
}
